import { render, staticRenderFns } from "./ListArticle.vue?vue&type=template&id=cf7c1926&scoped=true"
import script from "./ListArticle.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListArticle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListArticle.vue?vue&type=style&index=0&id=cf7c1926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf7c1926",
  null
  
)

export default component.exports